const { map } = require('lodash')
import { challengeStatus } from '@/services/challengeStatus.enum'

export default {
  SET_USER_LOCATION(state, userLocation) {
    state.userLocation = userLocation
  },
  SET_GAME(state, game) {
    state.game = game
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage
  },
  SET_IS_USER_AT_CHALLENGE_LOCATION(state, { isUserInOneZone, challengeId }) {
    state.isUserAtChallengeLocation = { isUserInOneZone, challengeId }
  },
  SET_CHALLENGES_LOCATIONS(state, challengesLocations) {
    // First set it to 'null' to be sure to trigger the 'challengesLocations' watcher in Map.vue
    state.challengesLocations = null
    state.challengesLocations = challengesLocations
  },
  SET_DRAWER_STATE(state, drawerState) {
    state.drawerState = drawerState
  },
  SET_FINGERPRINT(state, fingerprint) {
    state.fingerprint = fingerprint
  },
  SET_CONFIG(state, config) {
    state.config = config
  },
  SET_TENANT(state, tenant) {
    state.tenant = tenant
  },
  SET_TEAM(state, team) {
    state.team = team
  },
  SET_API_KEY(state, apiKey) {
    state.apiKey = apiKey
  },
  UNLOCK_CHALLENGE(state, unlockedChallengeObj) {
    const challengesWithUpdatedOne = map(state.challengesLocations, c => {
      if (c.challengeId === unlockedChallengeObj.challengeId) {
        c.status = challengeStatus.UNLOCKED
        c.type = unlockedChallengeObj.type
        c.question = unlockedChallengeObj.question
        if (unlockedChallengeObj.answers) {
          c.answers = unlockedChallengeObj.answers
        }
      }
      return c
    })
    state.challengesLocations = challengesWithUpdatedOne
  },
  MARK_CHALLENGE_AS_DONE(state, { challengeId, challengeAnswer }) {
    state.challengesLocations = map(state.challengesLocations, c => {
      if (c.challengeId === challengeId) {
        c.status = challengeStatus.SOLVED
        c.chosenAnswer = challengeAnswer
      }
      return c
    })
  },
  MARK_CHALLENGE_AS_FAILED(state, { challengeId, challengeAnswer }) {
    state.challengesLocations = map(state.challengesLocations, c => {
      if (c.challengeId === challengeId) {
        c.status = challengeStatus.FAILED
        c.chosenAnswer = challengeAnswer
      }
      return c
    })
  },
  UPDATE_CHALLENGE_REMAINING_ATTEMPTS(state, { challengeId, remainingAttempts }) {
    state.challengesLocations = map(state.challengesLocations, c => {
      if (c.challengeId === challengeId) {
        c.remainingAttempts = remainingAttempts
      }
      return c
    })
  },
  SET_USER_SCORE(state, totalPoints) {
    state.userScore = totalPoints
  },
  ADD_POINTS_TO_USER_SCORE(state, pointsToAdd) {
    state.userScore += pointsToAdd
  },
  SET_MAP_ZOOM(state, mapZoom) {
    state.mapZoom = mapZoom
  },
  SET_MAP_CENTER(state, mapCenter) {
    state.mapCenter = mapCenter
  },
  SET_QUESTION_RADIUS(state, questionRadius) {
    state.questionRadius = questionRadius
  },
  LAUNCH_TUTORIAL(state, newValue) {
    state.launchTutorial = newValue
  },
  IS_TUTORIAL_IN_PROGRESS(state, newValue) {
    state.tutorialInProgress = newValue
  },
  LOGIN(state) {
    state.isLoggedIn = true
  },
  LOGOUT(state) {
    state.isLoggedIn = false
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js